import { Application } from '@/types/application';
import { ComparerResults } from '@/types/comparer';
import { Metadata } from '@/types/metadata/metadata';
import { simpleComparer } from './compareCommon';
import { compareMetadata } from './compareMetadata';
import { comparePrompts } from './comparePrompts';
import { compareSubroutines } from './compareSubroutines';
import { compareVariables } from './compareVariables';

export const getAppLabel = (application: Application): string => {
  return `${application.label ?? application.name ?? application.applicationId} (rev ${application.revision})`;
};

export const compareApplications = (appA: Application, appB: Application, metadata: Metadata): ComparerResults => {
  const metadataChanges = compareMetadata(appA, appB);
  const subroutines = compareSubroutines(appA, appB, metadata);
  const variables = compareVariables(appA, appB);
  const prompts = comparePrompts(appA, appB);
  const signals = simpleComparer(appA.signals ?? [], appB.signals ?? [], 'id', 'name', [
    'name',
    'description',
    'substart'
  ]);
  const syncEvents = simpleComparer(appA.syncevents ?? [], appB.syncevents ?? [], 'name', 'name', ['state']);
  const userEvents = simpleComparer(appA.userevents ?? [], appB.userevents ?? [], 'event', 'event', ['label']);
  const semaphores = simpleComparer(appA.semaphores ?? [], appB.semaphores ?? [], 'id', 'name', ['name', 'value']);
  const queues = simpleComparer(appA.queues ?? [], appB.queues ?? [], 'queue', 'queue', [
    'description',
    'messages',
    'datatype'
  ]);
  const folders = simpleComparer(appA.folders ?? [], appB.folders ?? [], 'id', 'label', ['label', 'parentId']);

  const result = {
    metadata: metadataChanges,
    subroutines,
    variables,
    prompts,
    signals,
    userEvents,
    syncEvents,
    queues,
    semaphores,
    folders
  };

  return result;
};
